/*
 * Grippatch - motosiklet secici
 *
 * marka [-> model] -> eslesen urunler ayni sayfada listelenir
 *
 * NEDEN ARTIK SHOPIFY ARAMASINA GITMIYOR (2026-08-20, canli olculdu):
 * Onceki surum `/search?q="Marka Model"` gonderiyordu. Olcumler:
 *     "Honda PCX 125"                ->  24 urun
 *     "Honda PCX125"                 ->   1 urun
 *     "PCX 125" OR "PCX125"          ->  24  (yani OR BIRLESTIRMIYOR)
 *     "Honda CBR500"                 ->   2  (CBR500 Black'i de getiriyor)
 * Sonuc: arama ne yazim farkini tolere ediyor ne de kardes modeli ayikliyor.
 * Basliginda marka gecmeyen urunler (orn "GRIPPATCH PCX 125 ... KUYRUK
 * KORUMA") hic bulunamiyordu - musteri bunu "kodla aratinca cikiyor ama
 * modelin altinda yok" diye bildirdi.
 *
 * Eslesme artik URETIM ANINDA yapiliyor: `araclar/moto_index_uret.py` her
 * modelin urun handle'larini `assets/moto-index.json` icine yaziyor (surum 3).
 * Secici o listeyi okuyup urun kartlarini kendisi basiyor. Fiyat/gorsel
 * bilgisi `/products/<handle>.js` ile CANLI cekiliyor - index'te fiyat
 * tutulmuyor, bayatlama riski yok.
 *
 * Model secilmeden de sonuc verir: marka secip "Göster" denince o markanin
 * tum modellerindeki urunler birlestirilip listelenir.
 */

const SAYFA = 24;       // "modele ozel" grubunda ilk gosterilen urun sayisi
const SAYFA_GENEL = 12; // "marka geneli" grubunda ilk gosterilen urun sayisi

/* Belirli bir MODEL secilince o modelin urunleri TEK SEFERDE basilir; sinir
   yalniz "Tum modeller" secildiginde (100+ urun) uygulanir. Sebep - musteri
   bildirimi 2026-08-25: PCX 125'te 36 urun var, ilk 24'u basilinca "12 urun
   eksik" diye sayildi. "Daha fazla goster" dugmesi vardi ama sayim dugmenin
   ustunde bitiyor; bir modelin urun sayisi zaten bir ekrana sigacak kadar az. */

/* Basliginda MODEL gecmeyen, yalniz marka gecen urunler (fren kaliper
   sogutucusu, marka logolu anahtarlik vb.) index'te bu ad altinda toplaniyor.
   Bunlar markanin HER modeline uyar. */
const MARKA_GENELI = 'Universal (marka geneli)';

/* Index dosyasini tek bir ic bicime cevirir:
     { "Honda": { modeller: [{ad, urunler}], harf, renk, logo } }

   Uc disa bicimi kabul eder:
     surum 3 : modeller = [{ ad, urunler:[handle] }]      <- guncel
     surum 2 : modeller = ["SH 125", ...]                 <- urun baglantisi yok
     surum 1 : { "Honda": ["SH 125", ...] }               <- eski dosya
   Boylece JSON ile JS farkli anlarda guncellenirse secici bozulmaz. */
function normalize(data) {
  if (!data || typeof data !== 'object') return {};

  const modelleriDuzelt = (liste) =>
    (Array.isArray(liste) ? liste : []).map((m) =>
      typeof m === 'string'
        ? { ad: m, urunler: [] }
        : {
            ad: m.ad || '',
            urunler: Array.isArray(m.urunler) ? m.urunler : [],
            /* DIKKAT: bu fonksiyon indeksten SECEREK kopyaliyor. Yeni bir alan
               eklenince BURAYA da eklenmezse sessizce dusuyor - `genelYok`
               ve `logoRenkli` ilk denemede tam bu yuzden calismadi. */
            genelYok: m.genelYok === true,
          }
    );

  if (Array.isArray(data.markalar)) {
    const out = {};
    data.markalar.forEach((m) => {
      if (!m || !m.ad) return;
      out[m.ad] = {
        modeller: modelleriDuzelt(m.modeller),
        harf: m.harf || '',
        renk: m.renk || '',
        logo: m.logo || '',
        logoRenkli: m.logoRenkli || '',
      };
    });
    return out;
  }

  const out = {};
  Object.keys(data).forEach((ad) => {
    if (Array.isArray(data[ad])) {
      out[ad] = {
        modeller: modelleriDuzelt(data[ad]),
        harf: '',
        renk: '',
        logo: '',
        logoRenkli: '',
      };
    }
  });
  return out;
}

/* Magazanin KENDI para bicimiyle ayni: "9.200,00 TL" (binlik nokta,
   ondalik virgul). Magaza para bicimi 2026-08-20'de Turkce'ye cevrildi
   (Ayarlar > Genel > Para birimi bicimi, `amount_with_comma_separator`);
   bu satir o gun `en-US`den `tr-TR`ye alindi. Sunucunun bastigi fiyatlarla
   JS'in bastiklari AYNI sayfada goruntugu icin ikisi ayrismamali. */
const paraBicim = new Intl.NumberFormat('tr-TR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

function fiyatYaz(kurus) {
  if (typeof kurus !== 'number') return '';
  return paraBicim.format(kurus / 100) + ' TL';
}

function initFinder(root) {
  const form = root.querySelector('[data-finder-form]');
  const brand = root.querySelector('[data-brand]');
  const model = root.querySelector('[data-model]');
  const go = root.querySelector('[data-go]');
  const reset = root.querySelector('[data-reset]');
  const panel = root.querySelector('[data-finder-sonuc]');
  const src = root.dataset.index;

  if (!form || !brand || !model || !go || !src) return;

  const modelPlaceholder = model.options[0] ? model.options[0].textContent : '';
  let index = {};
  let bekleyen = { ozel: [], genel: [] }; // gruba gore cizilmemis handle'lar
  let ozelBoy = SAYFA;                   // 'modele ozel' grubunun parti boyu
  let istek = 0;       // yaris kosulu kilidi: son gonderim kazanir

  const varlikTaban = src.replace(/[^/]*(?:\?.*)?$/, '');

  const fill = (select, on) => {
    const field = select.closest('.finder__field');
    if (field) field.classList.toggle('is-filled', on);
  };

  const clearModels = (msg) => {
    model.innerHTML = '';
    const o = document.createElement('option');
    o.value = '';
    o.textContent = msg;
    model.appendChild(o);
    model.disabled = true;
    fill(model, false);
  };

  const setBrandState = (msg, enabled) => {
    brand.innerHTML = '';
    const o = document.createElement('option');
    o.value = '';
    o.textContent = msg;
    brand.appendChild(o);
    brand.disabled = !enabled;
  };

  const fillBrands = () => {
    const names = Object.keys(index).sort((a, b) => a.localeCompare(b, 'tr'));
    if (!names.length) {
      setBrandState(brand.dataset.empty || 'Liste bulunamadı', false);
      return;
    }
    setBrandState(brand.dataset.placeholder || 'Marka seçin', true);
    names.forEach((n) => {
      const o = document.createElement('option');
      o.value = n;
      o.textContent = n;
      /* Rozet verisi: dropdown.js bu alanlari okuyup adin soluna kucuk
         yuvarlak marka isareti koyuyor. `logo` yalniz dosya GERCEKTEN varsa
         index'e yaziliyor, boylece olmayan dosya icin 404 istegi atilmiyor. */
      const b = index[n] || {};
      if (b.harf) o.dataset.harf = b.harf;
      if (b.renk) o.dataset.renk = b.renk;
      if (b.logo) o.dataset.logo = varlikTaban + b.logo;
      /* Acik kip icin markanin RENKLI surumu. Koyu kipte beyaz siluet
         kullaniliyor; acik zeminde o kaybolduğu icin eskiden rozete koyu
         disk veriliyordu - musteri o siyahligi istemedi (2026-08-27). */
      if (b.logoRenkli) o.dataset.logoRenkli = varlikTaban + b.logoRenkli;
      brand.appendChild(o);
    });
  };

  /* ------------------------------------------------------ sonuc paneli */

  const panelKapat = () => {
    if (!panel) return;
    panel.hidden = true;
    panel.innerHTML = '';
    bekleyen = { ozel: [], genel: [] };
  };

  const kutuYaz = (html) => {
    if (!panel) return;
    panel.hidden = false;
    panel.innerHTML = html;
  };

  /* Marka + model secimine gore IKI liste doner:
       ozel  : secilen modele (ya da markanin modellerine) ait urunler
       genel : markanin her modeline uyan, basliginda model gecmeyen urunler

     NEDEN AYRI: once tek liste doneriyordu ve marka geneli urunler listenin
     SONUNA dusuyordu. Ilk 24 urun gosterildigi icin BMW'de fren kaliperi
     29. sirada kaliyor ve hic gorunmuyordu (olculdu 2026-08-25). Ustelik
     belirli bir MODEL secildiginde marka geneli urunler hic gelmiyordu -
     oysa onlar o modele de uyar. Iki liste ayri basliklarla basiliyor;
     boylece sira ve sayi ne olursa olsun ikisi de goruluyor. */
  const handleBul = (marka, modelAd) => {
    const b = index[marka];
    if (!b) return { ozel: [], genel: [] };

    const genelM = b.modeller.find((x) => x.ad === MARKA_GENELI);
    const genel = genelM ? genelM.urunler.slice() : [];

    if (modelAd && modelAd !== MARKA_GENELI) {
      const m = b.modeller.find((x) => x.ad === modelAd);
      const ozel = m ? m.urunler.slice() : [];
      /* DEPOSUZ MODEL: bazi modellerde (scooter'larin cogu) yakit deposu
         disaridan erisilebilir degil, universal tank pad UYGULANAMIYOR.
         Musteri bildirimi 2026-08-27: Honda PCX 125, ADV350, Forza 250/750,
         SH 125, Activa 125, Dio, X-ADV. Bu modeller secilince "marka geneli"
         grubu HIC gosterilmez - modele ozel urunler etkilenmez.
         Bayrak indekste: moto_index_uret.py `DEPOSUZ`. */
      if (m && m.genelYok) return { ozel: ozel, genel: [] };
      /* Ayni urun iki listede birden cikmasin. */
      return { ozel: ozel, genel: genel.filter((h) => ozel.indexOf(h) < 0) };
    }

    const gorulen = new Set();
    b.modeller.forEach((m) => {
      if (m.ad === MARKA_GENELI) return;
      m.urunler.forEach((h) => gorulen.add(h));
    });
    const ozel = [...gorulen];
    return { ozel: ozel, genel: genel.filter((h) => ozel.indexOf(h) < 0) };
  };

  const kartCiz = (u) => {
    const gorsel = u.featured_image
      ? u.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2')
      : '';
    const el = document.createElement('a');
    el.className = 'fsonuc__kart';
    el.href = u.url;
    el.innerHTML =
      '<span class="fsonuc__gorsel">' +
      (gorsel
        ? '<img src="' + gorsel + '" alt="" loading="lazy" decoding="async" width="200" height="200">'
        : '') +
      '</span>' +
      '<span class="fsonuc__ad"></span>' +
      '<span class="fsonuc__fiyat"></span>';
    // Baslik ve fiyat metin olarak yaziliyor (HTML enjeksiyonu olmasin).
    el.querySelector('.fsonuc__ad').textContent = u.title || '';
    el.querySelector('.fsonuc__fiyat').textContent = fiyatYaz(u.price);
    return el;
  };

  /* Her grubun KENDI butonu var. Once tek buton ve tek kuyruk vardi; ilk 24
     urunu "modele ozel" grubu tuketiyor, "marka geneli" grubu bos kaliyordu -
     yani cozmeye calistigimiz sorun bir adim otelenmis oluyordu. */
  const dahaFazlaCiz = (grup) => {
    const blok = panel.querySelector('[data-fgrup="' + grup + '"]');
    if (!blok) return;
    const eskiBtn = blok.querySelector('.fsonuc__daha');
    if (eskiBtn) eskiBtn.remove();
    const kalan = bekleyen[grup].length;
    if (!kalan) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'btn btn--ghost fsonuc__daha';
    b.textContent = kalan + ' ürün daha göster';
    b.addEventListener('click', () => partiCiz(grup));
    blok.appendChild(b);
  };

  /* Bir parti urunu cek ve ciz. Fiyat/gorsel CANLI geliyor - index'te
     tutulsaydi fiyat degisince bayatlardi. */
  const partiCiz = (grup) => {
    const benim = istek;
    const boy = grup === 'genel' ? SAYFA_GENEL : ozelBoy;
    const parti = bekleyen[grup].splice(0, boy);
    if (!parti.length) return;

    Promise.all(
      parti.map((h) =>
        fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    ).then((liste) => {
      if (benim !== istek) return; // arada yeni sorgu yapildi
      const g = panel.querySelector('[data-fgrid="' + grup + '"]');
      if (!g) return;
      liste.forEach((u) => {
        if (u) g.appendChild(kartCiz(u));
      });
      /* Hicbir urunu gelmediyse (hepsi 404) bos baslik birakma. */
      const blok = panel.querySelector('[data-fgrup="' + grup + '"]');
      if (blok) blok.hidden = g.children.length === 0;
      dahaFazlaCiz(grup);
    });
  };

  const sonucGoster = (marka, modelAd) => {
    if (!panel) return;
    istek += 1;
    const bulunan = handleBul(marka, modelAd);
    const handles = bulunan.ozel.concat(bulunan.genel);
    const baslik = modelAd ? marka + ' ' + modelAd : marka;

    if (!handles.length) {
      /* Index'te urun baglantisi yoksa (eski surum dosya ya da hic eslesme)
         kullaniciyi bos birakma - Shopify aramasina yolla. */
      const q = new URLSearchParams();
      q.set('q', '"' + baslik + '"');
      q.set('type', 'product');
      window.location.href =
        (root.dataset.searchUrl || '/search') + '?' + q.toString();
      return;
    }

    const grupHTML = (anahtar, etiket, adet) =>
      '<section class="fsonuc__grup" data-fgrup="' + anahtar + '" hidden>' +
      '<p class="fsonuc__grup-ad">' + etiket + ' <b>' + adet + '</b></p>' +
      '<div class="fsonuc__grid" data-fgrid="' + anahtar + '"></div>' +
      '</section>';

    kutuYaz(
      '<div class="fsonuc__hd">' +
        '<strong class="fsonuc__baslik"></strong>' +
        '<span class="fsonuc__adet"></span>' +
        '<button type="button" class="fsonuc__kapat" aria-label="Sonuçları kapat">&times;</button>' +
        '</div>' +
        (bulunan.ozel.length ? grupHTML('ozel', modelAd ? 'Bu modele özel' : 'Modele özel', bulunan.ozel.length) : '') +
        (bulunan.genel.length ? grupHTML('genel', 'Marka geneli - tüm modellere uyar', bulunan.genel.length) : '')
    );
    panel.querySelector('.fsonuc__baslik').textContent = baslik;
    panel.querySelector('.fsonuc__adet').textContent =
      handles.length + ' ürün';
    panel.querySelector('.fsonuc__kapat').addEventListener('click', panelKapat);

    ozelBoy =
      modelAd && modelAd !== MARKA_GENELI && bulunan.ozel.length
        ? bulunan.ozel.length
        : SAYFA;
    bekleyen = { ozel: bulunan.ozel.slice(), genel: bulunan.genel.slice() };
    partiCiz('ozel');
    partiCiz('genel');
    panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };

  /* ----------------------------------------------------------- olaylar */

  brand.addEventListener('change', () => {
    const val = brand.value;
    fill(brand, Boolean(val));
    panelKapat();

    if (!val) {
      clearModels(modelPlaceholder);
      go.disabled = true;
      if (reset) reset.hidden = true;
      return;
    }

    const list = (index[val] && index[val].modeller) || [];
    model.innerHTML = '';
    const first = document.createElement('option');
    first.value = '';
    /* Model secmek ARTIK ZORUNLU DEGIL: marka secilince buton aktif olur ve
       "Göster" markanin tum urunlerini listeler. Placeholder bunu soyluyor. */
    first.textContent = model.dataset.tumu || 'Tüm modeller';
    model.appendChild(first);

    /* "Universal (marka geneli)" listede GOSTERILMIYOR: o bir model degil,
       marka geneli urunlerin toplandigi kova. Icerigi artik hangi model
       secilirse secilsin ayri baslik altinda zaten cikiyor; listede model
       gibi durmasi yanilticiydi. */
    let gorunen = 0;
    list.forEach((m) => {
      if (m.ad === MARKA_GENELI) return;
      gorunen += 1;
      const o = document.createElement('option');
      o.value = m.ad;
      o.textContent = m.urunler.length
        ? m.ad + ' (' + m.urunler.length + ')'
        : m.ad;
      model.appendChild(o);
    });

    model.disabled = gorunen === 0;
    go.disabled = false;
    if (reset) reset.hidden = false;
  });

  model.addEventListener('change', () => {
    fill(model, Boolean(model.value));
    panelKapat();
  });

  /* Adres satirinda ?marka=..&model=.. varsa secimi kur ve sonucu goster.
     Paylasilan linkin ayni sonucu acmasini bu saglar. */
  const adrestenCalistir = () => {
    let q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    const marka = q.get('marka');
    if (!marka || !index[marka]) return;
    const modelAd = q.get('model') || '';

    brand.value = marka;
    brand.dispatchEvent(new Event('change'));
    if (modelAd) {
      const uygun = Array.prototype.some.call(model.options, (o) => o.value === modelAd);
      if (uygun) {
        model.value = modelAd;
        model.dispatchEvent(new Event('change'));
      }
    }
    /* Sayfada ozel sonuc bolumu (sections/moto-sonuc.liquid) varsa urun
       listesini O basar - kategori tasarimiyla. Paneli de doldurursak ayni
       sonuc iki kez, iki farkli tasarimda gorunur. Secimin ekranda gorunmesi
       icin acilir menuler yine de yukarida dolduruldu. */
    if (document.querySelector('[data-moto-sonuc]')) return;
    sonucGoster(marka, model.value);
  };

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!brand.value) return;

    /* Sonuc sayfasi tanimliysa panelde acma - AYRI SAYFAYA git.
       Boylece adres paylasilabilir olur: link acan ayni sonucu gorur.
       Tanimli degilse (sonuc sayfasinin kendi seciciler) panelde acilir. */
    const hedef = root.dataset.sonucUrl;
    if (hedef) {
      const q = new URLSearchParams();
      q.set('marka', brand.value);
      if (model.value) q.set('model', model.value);
      window.location.href = hedef + (hedef.indexOf('?') < 0 ? '?' : '&') + q.toString();
      return;
    }
    sonucGoster(brand.value, model.value);
  });

  if (reset) {
    reset.addEventListener('click', () => {
      brand.value = '';
      fill(brand, false);
      clearModels(modelPlaceholder);
      go.disabled = true;
      reset.hidden = true;
      panelKapat();
      brand.focus();
    });
  }

  setBrandState(brand.dataset.loading || 'Yükleniyor…', false);

  fetch(src, { headers: { Accept: 'application/json' } })
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
    .then((data) => {
      index = normalize(data);
      fillBrands();
      adrestenCalistir();
    })
    .catch(() => {
      // Liste cekilemezse secici sessizce bozulmasin: durumu soyle.
      setBrandState(brand.dataset.empty || 'Liste yüklenemedi', false);
    });
}

function initAllFinders() {
  document.querySelectorAll('[data-finder]').forEach((el) => {
    if (el.dataset.ready === '1') return;
    el.dataset.ready = '1';
    initFinder(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllFinders);
} else {
  initAllFinders();
}

document.addEventListener('shopify:section:load', initAllFinders);
